module.exports = __webpack_public_path__ + "img/pic1.c4203a3b.png";